import React from 'react';
import PropTypes from 'prop-types';
import { AsyncAutosuggest } from 'components';

const LessonAutosuggest = ({ value, label, handleChange }) => (
	<AsyncAutosuggest
		name="lesson_id"
		label={label}
		value={value}
		displayField="title"
		remoteUrl="/api/v1/admin/lessons"
		placeholder="Select"
		handleChange={handleChange}
	/>
);

LessonAutosuggest.propTypes = {
	value: PropTypes.number,
	label: PropTypes.string,
	handleChange: PropTypes.func.isRequired
};

export default LessonAutosuggest;
